export default __webpack_public_path__ + "static/media/blob_10.0b8515cb.mp4";